(function() {
  var SELECTORS = {
    root: '[data-bedroom-customizer]'
  };

  var SIZE_LABELS = {
    single: 'Single',
    semi_double: 'Semi Double',
    double: 'Double',
    queen: 'Queen'
  };

  var COLOR_LABELS = {
    pink: 'Pink',
    light_green: 'Light Green',
    ivory: 'Ivory',
    navy: 'Navy'
  };

  var FRAME_COLOR_LABELS = {
    natural: 'Natural',
    brown: 'Brown',
    charcoal: 'Charcoal'
  };

  var MODEL_MATERIAL_MAP = {
    pillowcase: 'Fabric-P',
    duvetCover: 'Fabric-S',
    fittedSheet: 'Fabric-M',
    bedFrame: ['ラバーウッド', 'ラワン_TOP', 'ラワン_EDGE']
  };

  var MODEL_COLOR_MAP = {
    white: [1, 1, 1, 1],
    pink: [0.82, 0.56, 0.57, 1],
    light_green: [0.65, 0.72, 0.61, 1],
    ivory: [0.89, 0.87, 0.79, 1],
    navy: [0.12, 0.18, 0.29, 1]
  };

  var MODEL_FRAME_COLOR_MAP = {
    none: [1, 1, 1, 1],
    natural: [0.72, 0.54, 0.34, 1],
    brown: [0.3, 0.16, 0.08, 1],
    charcoal: [0.13, 0.13, 0.14, 1]
  };

  var ORIGINAL_FRAME_TEXTURES = new WeakMap();
  var ORIGINAL_FABRIC_TEXTURES = new WeakMap();
  var MODEL_TEXTURE_CACHE = new WeakMap();

  var OPTION_NAME_ALIASES = {
    size: ['size', 'サイズ'],
    color: ['color', 'colour', 'カラー', '色', '色を選ぶ']
  };

  var SIZE_VALUE_ALIASES = {
    single: ['single', 'シングル'],
    semi_double: ['semi_double', 'semi double', 'semi-double', 'セミダブル'],
    double: ['double', 'ダブル'],
    queen: ['queen', 'クイーン']
  };

  var COLOR_VALUE_ALIASES = {
    pink: ['pink', 'ピンク'],
    light_green: ['light_green', 'light green', 'light-green', 'ライトグリーン'],
    ivory: ['ivory', 'アイボリー'],
    navy: ['navy', 'ネイビー']
  };

  var FRAME_COLOR_VALUE_ALIASES = {
    natural: ['natural', 'ナチュラル'],
    brown: ['brown', 'ブラウン'],
    charcoal: ['charcoal', 'チャコール']
  };

  function normalizeValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[\s/]+/g, '_')
      .replace(/-+/g, '_');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      maximumFractionDigits: 0
    }).format((cents || 0) / 100);
  }

  function uniqueSetId() {
    return 'bedroom-set-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
  }

  function canonicalizeOptionName(value) {
    var normalized = normalizeValue(value);
    var match = Object.keys(OPTION_NAME_ALIASES).find(function(key) {
      return OPTION_NAME_ALIASES[key].some(function(alias) {
        return normalizeValue(alias) === normalized;
      });
    });

    return match || normalized;
  }

  function canonicalizeSize(value) {
    var normalized = normalizeValue(value);
    var match = Object.keys(SIZE_VALUE_ALIASES).find(function(key) {
      return SIZE_VALUE_ALIASES[key].some(function(alias) {
        return normalizeValue(alias) === normalized;
      });
    });

    return match || normalized;
  }

  function canonicalizeColor(value) {
    var normalized = normalizeValue(value);
    var match = Object.keys(COLOR_VALUE_ALIASES).find(function(key) {
      return COLOR_VALUE_ALIASES[key].some(function(alias) {
        return normalizeValue(alias) === normalized;
      });
    });

    if (match) return match;

    var frameMatch = Object.keys(FRAME_COLOR_VALUE_ALIASES).find(function(key) {
      return FRAME_COLOR_VALUE_ALIASES[key].some(function(alias) {
        return normalizeValue(alias) === normalized;
      });
    });

    return frameMatch || normalized;
  }

  function canonicalizeByKey(key, value) {
    if (key === 'size') return canonicalizeSize(value);
    if (key === 'color') return canonicalizeColor(value);
    return normalizeValue(value);
  }

  function findVariant(product, conditions) {
    if (!product || !product.variants || !product.variants.length) {
      return null;
    }

    var optionNames = (product.options || []).map(canonicalizeOptionName);

    return product.variants.find(function(variant) {
      if (!variant.available) return false;

      return Object.keys(conditions).every(function(key) {
        var optionIndex = optionNames.findIndex(function(optionName) {
          return optionName === key;
        });

        if (optionIndex === -1) {
          return true;
        }

        return canonicalizeByKey(key, variant.options[optionIndex]) === canonicalizeByKey(key, conditions[key]);
      });
    }) || null;
  }

  function parseDataAttribute(node, name) {
    var raw = node.getAttribute(name);
    if (!raw) return {};

    try {
      return JSON.parse(raw);
    } catch (error) {
      console.warn('Failed to parse customizer data', name, error);
      return {};
    }
  }

  function syncChoiceGroup(root, groupName, currentValue) {
    root.querySelectorAll('[data-choice-group="' + groupName + '"] [data-choice-value]').forEach(function(button) {
      button.classList.toggle('is-active', button.getAttribute('data-choice-value') === currentValue);
    });
  }

  function setError(root, message) {
    var node = root.querySelector('[data-error]');
    if (!node) return;

    if (!message) {
      node.hidden = true;
      node.textContent = '';
      return;
    }

    node.hidden = false;
    node.textContent = message;
  }

  function setDebugValue(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) {
      node.textContent = value;
    }
  }

  function setPlaceholderVisible(root, shouldShow) {
    var placeholder = root.querySelector('[data-preview-placeholder]');
    if (!placeholder) return;

    placeholder.hidden = !shouldShow;
  }

  function setDragIndicatorHidden(root, hidden) {
    var indicator = root.querySelector('[data-drag-indicator]');
    if (!indicator) return;

    indicator.classList.toggle('is-hidden', hidden);
  }

  function getModelScene(modelViewer) {
    if (!modelViewer || !modelViewer.model || !modelViewer.model.materials) {
      return null;
    }

    return modelViewer.model;
  }

  function findModelMaterial(modelViewer, materialName) {
    var scene = getModelScene(modelViewer);
    if (!scene) return null;

    return scene.materials.find(function(material) {
      return normalizeValue(material.name) === normalizeValue(materialName);
    }) || null;
  }

  function applyMaterialColor(material, colorKey) {
    var color = MODEL_COLOR_MAP[colorKey];

    if (!material || !color || !material.pbrMetallicRoughness || !material.pbrMetallicRoughness.setBaseColorFactor) {
      return false;
    }

    material.pbrMetallicRoughness.setBaseColorFactor(color);
    if (material.pbrMetallicRoughness.setMetallicFactor) {
      material.pbrMetallicRoughness.setMetallicFactor(0);
    }
    if (material.pbrMetallicRoughness.setRoughnessFactor) {
      material.pbrMetallicRoughness.setRoughnessFactor(0.92);
    }
    return true;
  }

  function rememberFabricTexture(material) {
    if (!material || ORIGINAL_FABRIC_TEXTURES.has(material)) return;

    var textureInfo = material.pbrMetallicRoughness && material.pbrMetallicRoughness.baseColorTexture;
    ORIGINAL_FABRIC_TEXTURES.set(material, {
      texture: textureInfo ? textureInfo.texture || null : null
    });
  }

  function getOrCreateTexture(modelViewer, url) {
    var cache = MODEL_TEXTURE_CACHE.get(modelViewer);
    if (!cache) {
      cache = {};
      MODEL_TEXTURE_CACHE.set(modelViewer, cache);
    }

    if (!cache[url]) {
      cache[url] = modelViewer.createTexture(url).catch(function(error) {
        delete cache[url];
        throw error;
      });
    }

    return cache[url];
  }

  function applyFabricMaterial(root, modelViewer, material, colorKey, textureMap, appearanceVersion) {
    if (!material || !material.pbrMetallicRoughness) return false;

    var pbr = material.pbrMetallicRoughness;
    var textureInfo = pbr.baseColorTexture;
    var textureUrl = textureMap[colorKey];
    rememberFabricTexture(material);

    if (pbr.setMetallicFactor) pbr.setMetallicFactor(0);
    if (pbr.setRoughnessFactor) pbr.setRoughnessFactor(0.92);

    if (textureUrl && textureInfo && textureInfo.setTexture && modelViewer.createTexture) {
      pbr.setBaseColorFactor([1, 1, 1, 1]);
      getOrCreateTexture(modelViewer, textureUrl).then(function(texture) {
        if (root.dataset.appearanceVersion !== appearanceVersion) return;
        textureInfo.setTexture(texture);
        setDebugValue(root, '[data-debug-status]', 'Model loaded / material textures synced');
      }).catch(function(error) {
        if (root.dataset.appearanceVersion !== appearanceVersion) return;
        console.warn('Failed to load bedroom material texture', textureUrl, error);
        applyMaterialColor(material, colorKey);
      });
      return true;
    }

    if (textureInfo && textureInfo.setTexture) {
      textureInfo.setTexture(ORIGINAL_FABRIC_TEXTURES.get(material).texture);
    }
    return applyMaterialColor(material, colorKey);
  }

  function applyFrameMaterialColor(material, colorKey) {
    var color = MODEL_FRAME_COLOR_MAP[colorKey] || MODEL_FRAME_COLOR_MAP.none;

    if (!material || !material.pbrMetallicRoughness || !material.pbrMetallicRoughness.setBaseColorFactor) {
      return false;
    }

    var textureInfo = material.pbrMetallicRoughness.baseColorTexture;
    if (textureInfo && textureInfo.setTexture) {
      if (!ORIGINAL_FRAME_TEXTURES.has(material)) {
        ORIGINAL_FRAME_TEXTURES.set(material, { texture: textureInfo.texture || null });
      }

      var original = ORIGINAL_FRAME_TEXTURES.get(material);
      textureInfo.setTexture(colorKey === 'none' ? null : original.texture);
    }

    material.pbrMetallicRoughness.setBaseColorFactor(color);
    return true;
  }

  function syncModelMaterials(root, state, textureMap) {
    var modelViewer = root.querySelector('[data-model-viewer]');
    if (!modelViewer || modelViewer.dataset.loaded !== 'true') return;

    var appearanceVersion = String((Number(root.dataset.appearanceVersion) || 0) + 1);
    root.dataset.appearanceVersion = appearanceVersion;

    var pillowMaterial = findModelMaterial(modelViewer, MODEL_MATERIAL_MAP.pillowcase);
    var duvetMaterial = findModelMaterial(modelViewer, MODEL_MATERIAL_MAP.duvetCover);
    var fittedMaterial = findModelMaterial(modelViewer, MODEL_MATERIAL_MAP.fittedSheet);
    var frameMaterials = MODEL_MATERIAL_MAP.bedFrame.map(function(materialName) {
      return findModelMaterial(modelViewer, materialName);
    }).filter(Boolean);

    var pillowApplied = applyFabricMaterial(root, modelViewer, pillowMaterial, state.pillowcase.included ? state.pillowcase.color : 'white', textureMap, appearanceVersion);
    var duvetApplied = applyFabricMaterial(root, modelViewer, duvetMaterial, state.duvetCover.included ? state.duvetCover.color : 'white', textureMap, appearanceVersion);
    var fittedApplied = applyFabricMaterial(root, modelViewer, fittedMaterial, state.fittedSheet.included ? state.fittedSheet.color : 'white', textureMap, appearanceVersion);
    var frameColor = state.bedFrame.type === 'none' ? 'none' : state.bedFrame.color;
    var frameApplied = false;
    frameMaterials.forEach(function(material) {
      frameApplied = applyFrameMaterialColor(material, frameColor) || frameApplied;
    });

    if (pillowApplied || duvetApplied || fittedApplied || frameApplied) {
      setDebugValue(root, '[data-debug-status]', 'Model loaded / materials synced');
    }
  }

  function buildItems(state, catalog) {
    var pillowVariant = findVariant(catalog.pillowcase, { color: state.pillowcase.color });
    var duvetVariant = findVariant(catalog.duvetCover, { size: state.duvetCover.size, color: state.duvetCover.color });
    var fittedVariant = findVariant(catalog.fittedSheet, { size: state.fittedSheet.size, color: state.fittedSheet.color });
    var frameProduct = state.bedFrame.type === 'none' ? null : catalog[state.bedFrame.type];
    var frameConditions = { size: state.bedFrame.size };

    if (state.bedFrame.type === 'bedFrameA' || state.bedFrame.type === 'bedFrameB') {
      frameConditions.color = state.bedFrame.color;
    }

    var frameVariant = frameProduct ? findVariant(frameProduct, frameConditions) : null;
    var items = [];

    if (state.pillowcase.included) {
      items.push({
        key: 'pillowcase',
        label: catalog.pillowcase.title || 'Pillowcase',
        variant: pillowVariant,
        quantity: 1,
        selectedSize: '2-piece set',
        selectedColor: COLOR_LABELS[state.pillowcase.color] || state.pillowcase.color,
        discountEligible: true
      });
    }

    if (state.duvetCover.included) {
      items.push({
        key: 'duvetCover',
        label: catalog.duvetCover.title || 'Duvet cover',
        variant: duvetVariant,
        quantity: 1,
        selectedSize: SIZE_LABELS[state.duvetCover.size] || state.duvetCover.size,
        selectedColor: COLOR_LABELS[state.duvetCover.color] || state.duvetCover.color,
        discountEligible: true
      });
    }

    if (state.fittedSheet.included) {
      items.push({
        key: 'fittedSheet',
        label: catalog.fittedSheet.title || 'Fitted sheet',
        variant: fittedVariant,
        quantity: 1,
        selectedSize: SIZE_LABELS[state.fittedSheet.size] || state.fittedSheet.size,
        selectedColor: COLOR_LABELS[state.fittedSheet.color] || state.fittedSheet.color,
        discountEligible: true
      });
    }

    if (frameProduct) {
      items.push({
        key: state.bedFrame.type,
        label: frameProduct.title || 'Bed frame',
        variant: frameVariant,
        quantity: 1,
        selectedSize: SIZE_LABELS[state.bedFrame.size] || state.bedFrame.size,
        selectedColor: FRAME_COLOR_LABELS[state.bedFrame.color] || state.bedFrame.color,
        discountEligible: false
      });
    }

    var itemOrder = { fittedSheet: 1, duvetCover: 2, pillowcase: 3, bedFrameA: 4, bedFrameB: 4 };
    return items.sort(function(a, b) {
      return itemOrder[a.key] - itemOrder[b.key];
    });
  }

  function isLinenBundleEligible(state) {
    return state.pillowcase.included && state.duvetCover.included && state.fittedSheet.included;
  }

  function isFrameBundleEligible(state) {
    return isLinenBundleEligible(state) && (state.bedFrame.type === 'bedFrameA' || state.bedFrame.type === 'bedFrameB');
  }

  function getActiveModelSrc(state, catalog, modelMap) {
    var duvetVariant = findVariant(catalog.duvetCover, { size: state.duvetCover.size, color: state.duvetCover.color });
    var fittedVariant = findVariant(catalog.fittedSheet, { size: state.fittedSheet.size, color: state.fittedSheet.color });
    var pillowVariant = findVariant(catalog.pillowcase, { color: state.pillowcase.color });
    var frameModel = state.bedFrame.type === 'bedFrameB' ? modelMap.bedFrameB : modelMap.bedFrameA;

    return (
      frameModel ||
      (duvetVariant && duvetVariant.modelUrl) ||
      (fittedVariant && fittedVariant.modelUrl) ||
      (pillowVariant && pillowVariant.modelUrl) ||
      ''
    );
  }

  function updateSummary(root, items, discountPercent, frameDiscountAmount, state) {
    var summary = root.querySelector('[data-summary]');
    var subtotalNode = root.querySelector('[data-subtotal-price]');
    var discountNode = root.querySelector('[data-discount-price]');
    var frameDiscountRow = root.querySelector('[data-frame-discount-row]');
    var frameDiscountNode = root.querySelector('[data-frame-discount-price]');
    var totalNode = root.querySelector('[data-total-price]');
    var discountLabel = root.querySelector('[data-discount-label]');
    var subtotal = 0;
    var discountableSubtotal = 0;
    var eligible = isLinenBundleEligible(state);
    var frameEligible = isFrameBundleEligible(state);

    if (!subtotalNode || !discountNode || !totalNode) return;

    if (summary) summary.innerHTML = '';

    items.forEach(function(item) {
      if (item.variant) {
        subtotal += (item.variant.price || 0) * item.quantity;
        if (item.discountEligible) {
          discountableSubtotal += (item.variant.price || 0) * item.quantity;
        }
      }

      if (summary) {
        var row = document.createElement('div');
        row.className = 'bedroom-customizer__summary-item';
        row.innerHTML = [
          '<div>',
          '<strong>' + item.label + '</strong>',
          '<span>Size: ' + item.selectedSize + '</span>',
          '<span>Color: ' + item.selectedColor + '</span>',
          '<span>Qty: ' + item.quantity + '</span>',
          '</div>',
          '<strong>' + (item.variant ? formatMoney((item.variant.price || 0) * item.quantity) : 'Unavailable') + '</strong>'
        ].join('');
        summary.appendChild(row);
      }
    });

    if (summary && !items.length) {
      summary.innerHTML = '<p class="bedroom-customizer__empty-summary">商品が選択されていません。</p>';
    }

    var discount = eligible ? Math.round(discountableSubtotal * discountPercent / 100) : 0;
    var frameDiscount = frameEligible ? Math.min(frameDiscountAmount, Math.max(0, subtotal - discount)) : 0;
    subtotalNode.textContent = formatMoney(subtotal);
    discountNode.textContent = '−' + formatMoney(discount);
    totalNode.textContent = formatMoney(subtotal - discount - frameDiscount);

    if (frameDiscountRow) frameDiscountRow.hidden = !frameEligible;
    if (frameDiscountNode) frameDiscountNode.textContent = '−' + formatMoney(frameDiscount);

    if (discountLabel) {
      discountLabel.textContent = eligible ? '3点セット割（' + discountPercent + '%OFF）' : '3点セット割（対象外）';
    }

  }

  function updateViewer(root, state, catalog, modelMap) {
    var modelViewer = root.querySelector('[data-model-viewer]');
    var baseLabel = root.querySelector('[data-base-size-label]');
    var colorLabel = root.querySelector('[data-color-label]');
    var modelSrc = getActiveModelSrc(state, catalog, modelMap);

    if (baseLabel) {
      baseLabel.textContent = SIZE_LABELS[state.baseSize] || state.baseSize;
    }

    if (colorLabel) {
      colorLabel.textContent = state.pillowcase.included ? (COLOR_LABELS[state.pillowcase.color] || state.pillowcase.color) : 'Pillowcase: None';
    }

    if (!modelViewer) return;

    setDebugValue(root, '[data-debug-model-viewer]', window.customElements && customElements.get('model-viewer') ? 'Loaded' : 'Not loaded');
    setDebugValue(root, '[data-debug-src]', modelSrc || 'Not set');

    if (modelSrc) {
      if (modelViewer.getAttribute('src') !== modelSrc) {
        modelViewer.dataset.loaded = 'false';
        modelViewer.setAttribute('src', modelSrc);
        setPlaceholderVisible(root, true);
        setDragIndicatorHidden(root, false);
        setDebugValue(root, '[data-debug-status]', 'Source assigned');
      } else if (modelViewer.dataset.loaded === 'true') {
        setPlaceholderVisible(root, false);
      }
    } else {
      modelViewer.dataset.loaded = 'false';
      modelViewer.removeAttribute('src');
      setPlaceholderVisible(root, true);
      setDragIndicatorHidden(root, true);
      setDebugValue(root, '[data-debug-status]', 'No GLB configured');
    }
  }

  function syncFrameCardImages(root, state, catalog) {
    ['bedFrameA', 'bedFrameB'].forEach(function(frameType) {
      var product = catalog[frameType];
      var image = root.querySelector('[data-choice-value="' + frameType + '"] img');
      if (!product || !image) return;

      var isSelected = state.bedFrame.type === frameType;
      var color = frameType === 'bedFrameB' && state.bedFrame.color === 'charcoal' ? 'natural' : state.bedFrame.color;
      var variant = isSelected ? findVariant(product, { size: state.bedFrame.size, color: color }) : null;
      var imageUrl = variant && variant.featuredImage ? variant.featuredImage : product.featuredImage;
      image.setAttribute('alt', variant && variant.title ? product.title + ' - ' + variant.title : product.title);
      if (!imageUrl || image.getAttribute('src') === imageUrl) return;

      image.removeAttribute('srcset');
      image.setAttribute('src', imageUrl);
    });
  }

  function syncFields(root, state, catalog) {
    syncChoiceGroup(root, 'pillowcase-color', state.pillowcase.color);
    syncChoiceGroup(root, 'duvet-color', state.duvetCover.color);
    syncChoiceGroup(root, 'fitted-color', state.fittedSheet.color);
    syncChoiceGroup(root, 'frame-type', state.bedFrame.type);

    var duvetSize = root.querySelector('[data-field="duvet-size"]');
    var fittedSize = root.querySelector('[data-field="fitted-size"]');
    var frameSize = root.querySelector('[data-field="frame-size"]');
    var frameColor = root.querySelector('[data-field="frame-color"]');

    if (duvetSize) duvetSize.value = state.duvetCover.included ? state.duvetCover.size : 'none';
    if (fittedSize) fittedSize.value = state.fittedSheet.included ? state.fittedSheet.size : 'none';
    if (frameSize) frameSize.value = state.bedFrame.size;
    if (frameColor) frameColor.value = state.bedFrame.color;

    var frameFields = root.querySelector('[data-component-fields="bedFrame"]');
    if (frameFields) frameFields.hidden = state.bedFrame.type === 'none';

    var pillowToggle = root.querySelector('[data-pillow-inclusion-toggle]');
    if (pillowToggle) {
      pillowToggle.textContent = state.pillowcase.included ? 'なし' : '追加する';
      pillowToggle.classList.toggle('is-restore', !state.pillowcase.included);
    }

    var frameColorField = root.querySelector('[data-frame-color-field]');
    if (frameColorField) {
      frameColorField.hidden = state.bedFrame.type === 'none';
    }

    var charcoalOption = root.querySelector('[data-field="frame-color"] option[value="charcoal"]');
    if (charcoalOption) {
      charcoalOption.disabled = state.bedFrame.type === 'bedFrameB';
      charcoalOption.hidden = state.bedFrame.type === 'bedFrameB';
    }

    syncFrameCardImages(root, state, catalog);

    var stepSummaries = {
      pillowcase: state.pillowcase.included ? (COLOR_LABELS[state.pillowcase.color] || state.pillowcase.color) : 'なし',
      duvetCover: state.duvetCover.included
        ? (COLOR_LABELS[state.duvetCover.color] || state.duvetCover.color) + ', ' + (SIZE_LABELS[state.duvetCover.size] || state.duvetCover.size)
        : 'なし',
      fittedSheet: state.fittedSheet.included
        ? (COLOR_LABELS[state.fittedSheet.color] || state.fittedSheet.color) + ', ' + (SIZE_LABELS[state.fittedSheet.size] || state.fittedSheet.size)
        : 'なし',
      bedFrame: state.bedFrame.type === 'none'
        ? 'なし'
        : (FRAME_COLOR_LABELS[state.bedFrame.color] || state.bedFrame.color) + ', ' +
          (SIZE_LABELS[state.bedFrame.size] || state.bedFrame.size)
    };

    Object.keys(stepSummaries).forEach(function(key) {
      var summary = root.querySelector('[data-step-summary="' + key + '"]');
      if (summary) summary.textContent = stepSummaries[key];
    });
  }

  function initCustomizer(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var catalog = parseDataAttribute(root, 'data-product-catalog');
    var modelMap = parseDataAttribute(root, 'data-model-map');
    var textureMap = parseDataAttribute(root, 'data-texture-map');
    var defaultSize = normalizeValue(root.getAttribute('data-default-size')) || 'double';
    var defaultColor = normalizeValue(root.getAttribute('data-default-color')) || 'ivory';
    var discountPercent = Number(root.getAttribute('data-set-discount-percent')) || 0;
    var frameDiscountAmount = (Number(root.getAttribute('data-frame-set-discount-amount')) || 0) * 100;
    var discountCode = (root.getAttribute('data-discount-code') || '').trim();
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var rootUrl = root.getAttribute('data-root-url') || '/';

    var state = {
      baseSize: defaultSize,
      pillowcase: {
        included: true,
        color: defaultColor
      },
      duvetCover: {
        included: true,
        size: defaultSize,
        color: defaultColor
      },
      fittedSheet: {
        included: true,
        size: defaultSize,
        color: defaultColor
      },
      bedFrame: {
        type: 'none',
        size: defaultSize,
        color: 'natural'
      }
    };

    var modelViewer = root.querySelector('[data-model-viewer]');

    function waitForModelViewerLoad() {
      if (window.customElements && customElements.get('model-viewer')) {
        render();
        return;
      }

      setDebugValue(root, '[data-debug-model-viewer]', 'Loading...');
      setDebugValue(root, '[data-debug-status]', 'Waiting for model-viewer library');

      window.setTimeout(waitForModelViewerLoad, 250);
    }

    if (modelViewer) {
      modelViewer.addEventListener('pointerdown', function() {
        setDragIndicatorHidden(root, true);
      });

      modelViewer.addEventListener('load', function() {
        modelViewer.dataset.loaded = 'true';
        setPlaceholderVisible(root, false);
        setDebugValue(root, '[data-debug-status]', 'Model loaded');
        syncModelMaterials(root, state, textureMap);
      });

      modelViewer.addEventListener('error', function(event) {
        modelViewer.dataset.loaded = 'false';
        var detail = event && event.detail ? JSON.stringify(event.detail) : 'Unknown error';
        setDebugValue(root, '[data-debug-status]', 'Load error: ' + detail);
        setPlaceholderVisible(root, true);
        setDragIndicatorHidden(root, true);
      });
    }

    function render() {
      syncFields(root, state, catalog);
      updateViewer(root, state, catalog, modelMap);
      updateSummary(root, buildItems(state, catalog), discountPercent, frameDiscountAmount, state);
      syncModelMaterials(root, state, textureMap);
      setError(root, '');
    }

    root.querySelectorAll('[data-step-toggle]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var step = toggle.closest('[data-customizer-step]');
        var shouldOpen = !step.classList.contains('is-open');

        root.querySelectorAll('[data-customizer-step]').forEach(function(otherStep) {
          otherStep.classList.remove('is-open');
          var otherToggle = otherStep.querySelector('[data-step-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        if (shouldOpen) {
          step.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var pillowInclusionToggle = root.querySelector('[data-pillow-inclusion-toggle]');
    if (pillowInclusionToggle) {
      pillowInclusionToggle.addEventListener('click', function() {
        state.pillowcase.included = !state.pillowcase.included;
        render();
      });
    }

    root.querySelectorAll('[data-choice-group="frame-type"] [data-choice-value]').forEach(function(button) {
      button.addEventListener('click', function() {
        state.bedFrame.type = button.getAttribute('data-choice-value');
        if (state.bedFrame.type === 'bedFrameB' && state.bedFrame.color === 'charcoal') {
          state.bedFrame.color = 'natural';
        }
        render();
      });
    });

    root.querySelectorAll('[data-choice-group="pillowcase-color"] [data-choice-value]').forEach(function(button) {
      button.addEventListener('click', function() {
        state.pillowcase.included = true;
        state.pillowcase.color = button.getAttribute('data-choice-value');
        render();
      });
    });

    root.querySelectorAll('[data-choice-group="duvet-color"] [data-choice-value]').forEach(function(button) {
      button.addEventListener('click', function() {
        state.duvetCover.included = true;
        state.duvetCover.color = button.getAttribute('data-choice-value');
        render();
      });
    });

    root.querySelectorAll('[data-choice-group="fitted-color"] [data-choice-value]').forEach(function(button) {
      button.addEventListener('click', function() {
        state.fittedSheet.included = true;
        state.fittedSheet.color = button.getAttribute('data-choice-value');
        render();
      });
    });

    [
      ['[data-field="duvet-size"]', 'duvetCover', 'size'],
      ['[data-field="fitted-size"]', 'fittedSheet', 'size'],
      ['[data-field="frame-size"]', 'bedFrame', 'size'],
      ['[data-field="frame-color"]', 'bedFrame', 'color']
    ].forEach(function(config) {
      var field = root.querySelector(config[0]);
      if (!field) return;

      field.addEventListener('change', function(event) {
        var value = normalizeValue(event.target.value);
        var isLinenSize = config[2] === 'size' && (config[1] === 'duvetCover' || config[1] === 'fittedSheet');

        if (isLinenSize) {
          state[config[1]].included = value !== 'none';
          if (value !== 'none') state[config[1]].size = value;
        } else {
          state[config[1]][config[2]] = value;
        }
        render();
      });
    });

    var restartButton = root.querySelector('[data-customizer-restart]');
    if (restartButton) {
      restartButton.addEventListener('click', function() {
        state.baseSize = defaultSize;
        state.pillowcase.included = true;
        state.pillowcase.color = defaultColor;
        state.duvetCover.included = true;
        state.duvetCover.size = defaultSize;
        state.duvetCover.color = defaultColor;
        state.fittedSheet.included = true;
        state.fittedSheet.size = defaultSize;
        state.fittedSheet.color = defaultColor;
        state.bedFrame.type = 'none';
        state.bedFrame.size = defaultSize;
        state.bedFrame.color = 'natural';
        render();
      });
    }

    var addButton = root.querySelector('[data-add-set]');
    if (addButton) {
      addButton.addEventListener('click', function() {
        var items = buildItems(state, catalog);
        var bundleEligible = isLinenBundleEligible(state);
        var unavailableItem = items.find(function(item) {
          return !item.variant;
        });

        if (!items.length) {
          setError(root, 'カートに追加する商品を1点以上選んでください。');
          return;
        }

        if (unavailableItem) {
          setError(root, unavailableItem.label + ' の該当バリエーションが見つかりません。商品オプション名と値を確認してください。');
          return;
        }

        if (bundleEligible && discountPercent > 0 && !discountCode) {
          setError(root, '3点セット割引コードが未設定です。テーマエディタの「Shopify discount code」に割引コードを入力してください。');
          return;
        }

        setError(root, '');
        addButton.disabled = true;
        addButton.classList.add('btn--loading');

        var setId = uniqueSetId();
        var payload = {
          items: items.map(function(item) {
            return {
              id: item.variant.id,
              quantity: item.quantity,
              properties: {
                _customizer: 'Bedroom Customizer',
                _set_id: setId,
                'Component name': item.label,
                'Selected size': item.selectedSize,
                'Selected color': item.selectedColor,
                '_set_discount': discountPercent + '%'
              }
            };
          })
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then(function(response) {
            return response.json().then(function(data) {
              if (!response.ok) {
                throw data;
              }
              return data;
            });
          })
          .then(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            if (bundleEligible && discountCode) {
              window.location.href = rootUrl + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(cartUrl);
              return;
            }
            window.location.href = cartUrl;
          })
          .catch(function(error) {
            var message = error && (error.description || error.message);
            setError(root, message || 'カート追加に失敗しました。');
          })
          .finally(function() {
            addButton.disabled = false;
            addButton.classList.remove('btn--loading');
          });
      });
    }

    render();
    waitForModelViewerLoad();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(SELECTORS.root).forEach(initCustomizer);
  });

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector(SELECTORS.root);
    if (root) initCustomizer(root);
  });
})();
